import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import ColorPickerContainer from '../../../containers/ColorPickerContainer';
import LocaleText from '../../LocaleText';

class ColorPickerPopup extends React.Component {
    render() {
        const classes = ['popup'];
        const { onConfirm, onCancel, onClose, isVisible } = this.props;
        if (!isVisible) {
            return null;
        }
        if (/iPhone/.test(navigator.userAgent) && !window.MSStream) {
            classes.push('is-iphone');
        }
        return (
            <div className={classes.join(' ')}>
                <div className="popup__box">
                    <header className="popup__header">
                        <h3 className="popup__title">
                            <LocaleText textKey="popup.colorpicker.title" />
                        </h3>
                        <div className="popup__close" onClick={onClose}>
                            <Isvg src="/svg/cancel.svg" />
                        </div>
                    </header>
                    <div className="popup__body">
                        <ColorPickerContainer />
                    </div>
                    <div className="buttons">
                        <button onClick={onCancel}>
                            <LocaleText textKey="popup.cancel" />
                        </button>
                        <button className="is-primary" onClick={onConfirm}>
                            <LocaleText textKey="popup.confirm" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

ColorPickerPopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
};

ColorPickerPopup.defaultProps = {
    customColors: [],
};

export default ColorPickerPopup;
